<div class="dialogContainer">
  <div class="inputRow">
    <h4>These units were updated via Mass Update, but had errors when calculating the rating responses. Please review and update them as needed.</h4>
  </div>
  <div class="inputRow">
    <span class="spacer"></span>
    <mat-paginator [pageSize]="10" [showFirstLastButtons]=true></mat-paginator>
  </div>
  <table mat-table [dataSource]="datasource" class="paginatedTable bordered-table">
    <ng-container matColumnDef="modelSize">
      <th mat-header-cell *matHeaderCellDef>Model/Size</th>
      <td mat-cell *matCellDef="let record">{{ record.modelSize }}</td>
    </ng-container>
    <ng-container matColumnDef="errorMessage">
      <th mat-header-cell *matHeaderCellDef>Error Message</th>
      <td mat-cell *matCellDef="let record">{{ record.errorMessage }}</td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
  <div class="inputRow">
    <span class="spacer"></span>
    <button class="dialogButton warn-button" matButton="elevated" (click)="closeDialog()">Close</button>
  </div>
</div>
